
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinpimpri() {



    const cardData =
    {
        keyword: 'Bus On Rent in Pimpri Chinchwad',
        heading: 'Amruta Travels: Bus On Rent in Pimpri Chinchwad',
        headingDescription: 'Amruta Travels offers Pune to Pimpri Chinchwad Bus on Rent, providing a reliable and comfortable transportation solution for your city exploration. Whether you are planning a family outing, corporate event, or group tour, our well-maintained buses ensure a smooth and enjoyable journey to Mumbai is iconic landmarks. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, we make your Mumbai Darshan simple and stress-free. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. Book your Pune to Mumbai Darshan Bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Bus Hire in Hinjewadi Pune",
      "description": "Amruta Travels offers reliable bus hire services in Hinjewadi Pune for corporate offices, IT parks, and residential areas. Whether you're planning a company outing, a wedding shuttle, or a group trip, our fleet includes AC and non-AC buses suitable for all travel needs with experienced drivers ensuring a safe and comfortable ride."
    },
    {
      "name": "Bus on Rent in Aundh Pune",
      "description": "Book a bus on rent in Aundh with Amruta Travels for school trips, family functions, or corporate events. We offer flexible packages, a variety of seating capacities, and AC/non-AC options to ensure your group travels in comfort and convenience from Aundh to any destination in Maharashtra or beyond."
    },
    {
      "name": "Bus On Rent in Baner Pune",
      "description": "Looking for a reliable bus rental service in Baner Pune? Amruta Travels provides mini, midi, and full-sized buses for outstation tours, weddings, college trips, and more. Our buses are well-maintained, GPS-enabled, and driven by professional chauffeurs for a hassle-free journey."
    },
    {
      "name": "Bus On Rent in Bhosari Pune",
      "description": "Amruta Travels provides affordable and efficient bus rentals in Bhosari Pune for factory visits, school tours, and marriage events. Choose from a range of buses including AC and Non-AC options in multiple seating capacities from 17-seater to 50-seater for comfortable group travel."
    },
    {
      "name": "Mini Bus On Rent in Talawade Pune",
      "description": "Need a mini bus in Talawade for a small group trip or corporate shuttle? Amruta Travels offers 14 to 26 seater mini buses with AC, clean interiors, and professional drivers. Ideal for IT park transfers, weekend outings, and short-distance travel from Talawade."
    },
    {
      "name": "Tempo Traveller on Rent in Pimpri Chinchwad",
      "description": "For small group travel, Amruta Travels offers Tempo Traveller rental services in Pimpri Chinchwad. Choose from 9, 12, 14, or 17 seater options with AC, push-back seats, and ample luggage space—perfect for outstation trips, family functions, and employee transport."
    },
    {
      "name": "17 Seater Bus on Rent in Akurdi Pune",
      "description": "Hire a 17 seater bus in Akurdi Pune for school picnics, religious tours, or company events. Our buses are equipped with air-conditioning, comfortable seating, and expert drivers to make your journey smooth and pleasant from Akurdi to any outstation destination."
    },
    {
      "name": "14, 17, 20, 25 Seater Bus Hire in Pimpri Chinchwad",
      "description": "Amruta Travels offers flexible seating options in Pimpri Chinchwad with 14, 17, 20, and 25-seater buses available for rent. These mini and midi buses are ideal for mid-sized group travel to tourist destinations, wedding venues, or corporate outings with both AC and Non-AC variants."
    },
    {
      "name": "32, 35, 40, 45 Seater Bus Hire in Pimpri Chinchwad",
      "description": "For large group transportation needs, Amruta Travels provides 32 to 45-seater buses in Pimpri Chinchwad. Whether it’s for school tours, pilgrimage trips, or company picnics, our buses come with spacious seating, air conditioning, and courteous drivers to ensure a safe and enjoyable ride."
    },
    {
      "name": "Bus On Rent in Wakad Pune",
      "description": "Amruta Travels serves Wakad Pune with a variety of buses for rent including 17 to 50 seaters. Whether you're planning an outstation tour, wedding event, or school trip, our buses are clean, safe, and offer a reliable transportation solution at competitive rates."
    },
    {
      "name": "Bus on Rent in Pimple Gurav Pune",
      "description": "Travel worry-free with Amruta Travels’ bus rental services in Pimple Gurav. Choose from mini buses, mid-size coaches, or full-size buses for events, tourism, or group shuttles. Our buses are well-maintained and suited for both local and outstation travel from Pimple Gurav."
    },
    {
      "name": "Urbania Bus on Rent in Pimpri Chinchwad",
      "description": "For luxury travel, book a Force Urbania mini bus in Pimpri Chinchwad through Amruta Travels. These 13 to 17-seater premium vehicles offer top-tier comfort, AC, plush seating, and modern interiors—perfect for high-end corporate trips, VIP transfers, and family tours."
    }
  ],
  "tableData": [
    ["Bus Hire in Hinjewadi Pune", "Bus on Rent in Aundh Pune"],
    ["Bus On Rent in Baner Pune", "Bus On Rent in Bhosari Pune"],
    ["Mini Bus On Rent in Talawade Pune", "Tempo Traveller on Rent in Pimpri Chinchwad"],
    ["17 Seater bus on Rent in Akurdi Pune", "14, 17, 20, 25 Seater Bus Hire in Pimpri Chinchwad"],
    ["32, 35, 40, 45 Seater Bus Hire in Pimpri Chinchwad", "Bus On Rent in Wakad Pune"],
    ["Bus on Rent in Pimple Gurav Pune", "Urbania Bus on Rent in Pimpri Chinchwad"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Convenient and Comfortable Bus Rentals in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels offers Bus on Rent in Pimpri Chinchwad, providing a comfortable, hassle-free travel experience for all your group transportation needs. Whether you are planning a family trip, corporate event, or school outing, our buses are equipped with spacious seating, air conditioning, and modern amenities to ensure a smooth and enjoyable journey. Travel in comfort and style within Pimpri Chinchwad and beyond with our well-maintained buses."
  },
  {
    "WhyChooseheading": "Ideal for Group Outings, Corporate Events, and School Trips",
    "WhyChoosedescription": "Our bus rental service is perfect for group outings, corporate events, school trips, and family gatherings. Whether you need to transport a large group for a team-building activity, a conference, or a local sightseeing tour, our buses provide ample space and comfort. We accommodate all types of group travel, ensuring that every journey is smooth, enjoyable, and punctual."
  },
  {
    "WhyChooseheading": "Experienced Drivers Ensuring Safe and Smooth Journeys",
    "WhyChoosedescription": "Safety and professionalism are our top priorities. Our experienced drivers are familiar with the local roads in Pimpri Chinchwad and surrounding areas, ensuring a safe and timely arrival at your destination. They are courteous, well-trained, and prioritize the comfort and safety of all passengers. With their knowledge of the routes and traffic conditions, they make sure your journey is both enjoyable and stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Bus on Rent in Pimpri Chinchwad. We provide clear, upfront rates with no hidden charges or surprises, allowing you to plan your travel expenses with confidence. Whether you're traveling for a day trip or an extended journey, we provide cost-effective solutions that meet your budget."
  },
  {
    "WhyChooseheading": "Well-Maintained, Clean, and Hygienic Buses",
    "WhyChoosedescription": "We ensure that our buses are regularly cleaned, serviced, and maintained to the highest standards. From comfortable seating to a well-kept interior, we take great care to provide a hygienic and pleasant environment for all passengers. You can trust that your journey will be both comfortable and safe, whether you're traveling a short distance or across longer routes."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations in Pimpri Chinchwad",
    "WhyChoosedescription": "We understand the importance of convenience. That’s why we offer flexible pick-up and drop-off locations throughout Pimpri Chinchwad, so you can choose where you want to start and end your journey. Whether it’s a residential area, office, or popular landmark, we cater to your preferred locations to ensure your travel is as seamless as possible."
  },
  {
    "WhyChooseheading": "Customizable Itineraries to Suit Your Group’s Needs",
    "WhyChoosedescription": "We offer fully customizable itineraries for your bus rental. Whether you want to make multiple stops, follow a specific route, or extend your travel time, we can adjust the plan to fit your group’s needs. Our goal is to ensure that your group’s travel experience is tailored to your preferences, giving you the freedom to create the perfect trip."
  },
  {
    "WhyChooseheading": "Easy Booking Process with Full Customer Support",
    "WhyChoosedescription": "Booking a bus in Pimpri Chinchwad with Amruta Travels is easy and convenient. You can quickly reserve your vehicle online, contact our customer support team, or visit our office for personalized assistance. Our dedicated team is always available to help with booking, route planning, and any additional questions or concerns to ensure a smooth experience from start to finish."
  }
]

























    }

const faqData = [
  {
    question: 'How can I rent a bus in Pimpri Chinchwad?',
    answer: 'Renting a bus in Pimpri Chinchwad with Amruta Travels is easy. You can book online, call our support team, or visit our office. We’ll help you select the best bus based on your group size and travel requirements.',
  },
  {
    question: 'What types of buses are available for rent in Pimpri Chinchwad?',
    answer: 'We offer a wide range of buses for rent in Pimpri Chinchwad, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have a suitable vehicle for your trip.',
  },
  {
    question: 'Are the buses comfortable for long journeys from Pimpri Chinchwad?',
    answer: 'Yes, our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. Whether it’s a short or long journey, you’ll have a comfortable ride throughout.',
  },
  {
    question: 'How much does it cost to rent a bus in Pimpri Chinchwad?',
    answer: 'The cost of renting a bus in Pimpri Chinchwad depends on the bus size, trip duration, and any additional services required. Please contact us for a detailed quote based on your travel plans.',
  },
  {
    question: 'Can I rent a bus for a one-day trip in Pimpri Chinchwad?',
    answer: 'Yes, we offer flexible options for one-day trips within Pimpri Chinchwad or surrounding areas. Just let us know your itinerary, and we’ll provide you with a customized solution.',
  },
  {
    question: 'Do you provide both standard and luxury buses for rent in Pimpri Chinchwad?',
    answer: 'Yes, we provide both standard and luxury buses. Our luxury buses come with premium amenities such as comfortable seating, air conditioning, and more, ensuring a high-quality experience for your trip.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations in Pimpri Chinchwad?',
    answer: 'Yes, we offer flexible pickup and drop-off locations in Pimpri Chinchwad. Just share your preferred locations, and we’ll tailor the route accordingly.',
  },
  {
    question: 'Why choose Amruta Travels for bus rental in Pimpri Chinchwad?',
    answer: 'Amruta Travels is known for reliable, comfortable, and safe bus rental services in Pimpri Chinchwad. Our buses are well-maintained, our drivers are experienced, and we prioritize customer satisfaction to make your trip stress-free and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    role: 'Event Coordinator, Pimpri Chinchwad',
    text: 'We rented a 35-seater bus from Amruta Travels for a corporate event in Pimpri Chinchwad. The service was excellent! The bus was clean, on time, and the driver was courteous and professional. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Deshmukh',
    role: 'Traveler, Pimpri Chinchwad',
    text: 'I booked a 45-seater bus for a family gathering in Pimpri Chinchwad. The bus was comfortable, and the driver ensured we had a smooth and safe journey. I would definitely use Amruta Travels again for future trips.',
    rating: 5,
  },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pimpri Chinchwad",
  "image": "https://bushireinpune.com/assets/images/bus-on-rent-in-pimpri-chinchwad.jpg",
  "description": "Book a bus on rent in Pimpri Chinchwad for local or outstation trips. Choose from mini buses, tempo travellers, and large buses for group travel, corporate outings, and events with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499", // Adjust the price accordingly
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-in-pimpri-chinchwad"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Bus on Rent in Pimpri Chinchwad | Affordable & Comfortable Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book buses on rent in Pimpri Chinchwad for local and outstation trips, corporate events, and group travel. Choose from 14, 17, 20, 25, 32, 35, 40, and 45-seater buses with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinpimpri;